import { ReactNode } from 'react'
import { Table, Thead } from './GenericTable.style'

type GenericTableProps = {
  children: ReactNode
  headers: ReactNode[]
  spacing: string
  font: string
  size?: string
  vendas?: boolean
  text?: boolean
  title4?: boolean
  title5?: boolean
}

export function GenericTable({
  headers,
  children,
  spacing,
  font,
  size,
  vendas,
  text,
  title4,
  title5,
}: GenericTableProps) {
  return (
    <Table size={size} border={0} cellPadding={0}>
      <Thead
        title4={title4}
        title5={title5}
        text={text}
        vendas={vendas}
        font={font}
        spacing={spacing}
      >
        <tr>
          {headers.map((titulo, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <th key={index}>{titulo}</th>
          ))}
        </tr>
      </Thead>
      <tbody>{children}</tbody>
    </Table>
  )
}
